(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ProductoListController', ProductoListController);
    

        ProductoListController.$inject = [
            '$templateCache',
            'productoService',
            '$scope',
            '$rootScope',
            '$state',
            '$filter',
            'notificationService',
            'simpleModalService',
            'common',
            'uiGridConstants', 
            'restrictionService'
        ];

    

        function ProductoListController(
            $templateCache,
            productoService,
            $scope,
            $rootScope,
            $state,
            $filter,
            notificationService,
            simpleModalService,
            common,
            uiGridConstants, 
            restrictionService
        ) {

        /* PRIVATE VARIABLES */
        var templates = {
			accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
			rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
        };

        var vm = this;
        vm.restrictionService = restrictionService; 
        vm.gridData = [];
        vm.rowCount = 0;
        vm.firstLoaded = false;
        vm.goToEdit = goToEdit;
        vm.filterGrid = filterGrid;
        vm.clearSearcher = clearSearcher;
        vm.searchText = '';
        vm.remove = remove; 
        vm.deleteAllItems = deleteAllItems; 

        vm.gridOptions = {
            enableFilter: true,
            rowTemplate: templates.rowTemplate,            
            columnDefs: [
                {
                    name: 'id',
                    displayName: 'ID',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },
                {
                    name: 'descripcion',
                    cellClass: 'strong', 
                    displayName: 'Nombre',
                    minWidth: 110,
                    resizable: true
                },
                {
                    name: 'porcentaje',
                    displayName: 'Porcentaje',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate
                }
             ],
			data: 'gridData',

			onRegisterApi: function (gridApi) {
				vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll= false;
			}
        };
        
        (function () {
            loadData();
        })();
        
        function loadData() {

            clearAll();
            
			productoService.getList().then(function (result) {
                $scope.gridData = result.data;
                vm.gridData = result.data;
                vm.rowCount = result.data.length;
                vm.firstLoaded = true; 
			});
        }

        function clearAll() {
            if (!common.isNullOrUndefined(vm.gridApi))
                vm.gridApi.selection.clearSelectedRows();
        }
        
        function goToEdit(col) {
            restrictionService.hasPermission('modificar', 'producto', 'flota.configuracion.editarProducto', { 'id': col.productoId });

		    //$state.go('flota.configuracion.editarProducto', { 'id': col.productoId });
        } 

            function remove(producto) {
             if (!restrictionService.hasPermission('eliminar', 'producto')) return; 

            notificationService.sendAppNotification({
                message: 'Dando de baja producto...',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
            productoService.deleteById([producto.productoId]).then(function () {
                loadData();
                clearSearcher();
                notificationService.sendAppNotification({
                    message: 'Producto dado de baja con �xito',
                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                });
            }, function () {
                notificationService.sendAppNotification({
                    message: 'Ha ocurrido un error al dar de baja el producto',
                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                });
            });
        }


        
            function deleteAllItems() {
                if (!restrictionService.hasPermission('eliminar', 'producto')) return; 
            simpleModalService
                .yesNoModal('Confirmaci�n eliminar', '�Desea eliminar los productos seleccionados?') // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                .then(function (result) {
                    if (result) {
                        var productsIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            productsIds.push(selected[i].productoId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Dando de baja productos...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        productoService.deleteById(productsIds)
                            .then(function () {
                                refreshGrid();
                                clearSearcher();
                                notificationService.sendAppNotification({
                                    message: 'Productos dados de baja con �xito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                            },
                            function () {
                                notificationService.sendAppNotification({
                                    message: 'Ha ocurrido un error al dar de baja los productos',
                                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                });
                            });
                    }
                });
        }

        function refreshGrid() {
            loadData();
        }

        function filterGrid() {
            if (vm.searchText !== '') {
                $scope.gridData = $filter('searchFilter')(vm.gridData, {
                        descripcion: vm.searchText,
                        precio: vm.searchText,
                        porcentaje: vm.searchText,
                        id: vm.searchText,
                    }, true);

                vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
            }
            else {
                $scope.gridData = vm.gridData;
                vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
            }

            vm.rowCount = $scope.gridData.length;
        }
        
        function clearSearcher() {
            vm.searchText = '';
            filterGrid();
        }
    }

})();

